export default __webpack_public_path__ + "static/media/loader.ee3fdf30.gif";